<template>
  <div class="content-image-slider">
    <Carousel :items-to-show="1.1" :snap-align="'start'" class="carousel">
      <Slide v-for="it in data.images" :key="it.id" class="item">
        <ContentImage :data="it" class="image" />
      </Slide>
      <template #addons>
        <Navigation>
          <template #next>
            <SvgArrowRight />
          </template>
          <template #prev>
            <SvgArrowLeft />
          </template>
        </Navigation>
      </template>
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import { Carousel, Slide, Navigation } from 'vue3-carousel';
import type { ContentImagesliderFragment } from '#gql';
import SvgArrowRight from '~/components/site-header/svgs/SvgArrowRight.vue';
import SvgArrowLeft from '~/components/site-header/svgs/SvgArrowLeft.vue';
import ContentImage from '~/components/content-modules/ContentImage.vue';

defineProps<{
  data: ContentImagesliderFragment;
}>();
</script>

<style scoped lang="scss">
.content-image-slider {
  @include grid-layout();

  & {
    --size-controls: 3rem;
    --width-items-to-show: 90.9091%;

    padding: var(--site-inner-padding);
    padding-bottom: calc(var(--size-controls) / 2);
    width: 100%;
    max-width: var(--site-max-width);
  }

  .carousel {
    width: 100%;
    grid-column: 1 / -1;
    text-align: left;

    @media (--md), (--lg) {
      grid-column: 3 / 23;
    }
  }

  .carousel__slide {
    height: 100%;
    padding-bottom: var(--spacing-4xs);

    @media (--xs), (--sm) {
      padding-right: var(--spacing-4xs);
    }

    @media (--md), (--lg) {
      padding-right: var(--spacing-3xs);
    }
  }

  :deep(.carousel__prev),
  :deep(.carousel__next) {
    outline: 2px solid var(--color-forest-dark);
    border-radius: 50%;
    width: calc(var(--size-controls) - 2px);
    height: calc(var(--size-controls) - 2px);
    margin-right: 1rem; // 1rem = padding-right from slide
    margin-left: unset;

    > .icon-arrow-right > path,
    > .icon-arrow-left > path {
      stroke: var(--color-forest-dark);
    }

    @media (--xs), (--sm) {
      margin-right: 0.5rem;
      scale: 0.9;
    }
  }

  :deep(.carousel__prev) {
    left: unset;
    top: 100%;
    right: calc(100% - var(--width-items-to-show) + (var(--size-controls) + 1rem));

    @media (--xs), (--sm) {
      right: calc(100% - var(--width-items-to-show) + (var(--size-controls) + 0.5rem));
    }
  }

  :deep(.carousel__next) {
    top: 100%;
    right: calc(100% - var(--width-items-to-show));
  }

  :deep(.content-image) {
    display: unset;
    padding: 0;
  }
}
</style>
